import React from 'react';
import ConfigService from "../../../Services/api/Config";

import './style.scss';

class IconMembers extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      members
    } = this.props;

    return (
      <span
        className='IconMembers'
        style={
          {
            borderColor: ConfigService.getColor('primaryColor'),
            color: ConfigService.getColor('primaryColor')
          }
        }
      >
        { members }
      </span>
    );
  }
}

export default IconMembers;